import { render, staticRenderFns } from "./bookDocList.vue?vue&type=template&id=e673c9e8&scoped=true"
import script from "./bookDocList.vue?vue&type=script&lang=js"
export * from "./bookDocList.vue?vue&type=script&lang=js"
import style0 from "./bookDocList.vue?vue&type=style&index=0&id=e673c9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e673c9e8",
  null
  
)

export default component.exports